<template>
  <section>
    <p class="text">{{ t('dashboard__text-no-selection') }}</p>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
section {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.text {
  @include font-mixins.desktop-regular-paragraph;
}
</style>
